import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faUserTie, 
  faBullhorn, 
  faComments,
  faPhone,
  faQrcode
} from '@fortawesome/free-solid-svg-icons';
import '../styles/TabBar.css';

const TabBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/', label: 'Ana Sayfa', icon: faHome },
    { path: '/baskan', label: 'Başkan', icon: faUserTie },
    { path: '/qr-kod-okuma', label: 'QR Kod', icon: faQrcode },
    { path: '/istek-sikayet', label: 'Şikayet/Öneri', icon: faComments },
    { path: '/iletisim', label: 'İletişim', icon: faPhone }
  ];

  return (
    <div className="tabbar-wrapper">
      <nav className="tab-bar">
        {tabs.map((tab) => (
          <button
            key={tab.path}
            className={`tab-item ${location.pathname === tab.path ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <FontAwesomeIcon icon={tab.icon} className="tab-icon" />
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>
      <div className="tabbar-footer">
        <span className="copyright-text">MuratSoft Yazılım 2026</span>
      </div>
    </div>
  );
};

export default TabBar; 